import styled, { css } from 'styled-components';

import { RouterLink } from 'components/Link';
import { colors, shadows, transition } from 'theme';

const pillCss = css`
  border-radius: 6px;
  color: ${colors.white};
  transition: ${transition};
  background: ${colors.brandBlue};
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding-left: 6px;
  padding-right: 6px;
  font-size: 13px;
  user-select: none;
  outline-color: ${colors.hoverBlue};
`;

const selectablePillCss = css`
  cursor: pointer;

  &:hover {
    color: ${colors.white};
    text-decoration: none;
    background: ${colors.hoverBlue};
  }
`;

export const CartPillDetails = styled.details`
  position: relative;
  display: inline-flex;

  &:not([open]) {
    --cart-pill-details-bottom-radius-multipler: 1;
  }

  &[open] {
    --cart-pill-details-bottom-radius-multipler: 0;

    summary {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
`;

export const CartPillSummary = styled.summary`
  &::marker {
    content: '';
  }

  ${pillCss};
  ${selectablePillCss};
`;

export const CartPillLink = styled(RouterLink)`
  ${pillCss};
  ${selectablePillCss};
`;

export const CartPillNoLink = styled.div`
  ${pillCss}
`;

export const CartPillCount = styled.span`
  width: 12px;
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
`;

export const CartPillListUl = styled.ul`
  position: absolute;
  right: 0;
  top: 100%;
  width: 147px;
  border: 1px solid ${colors.calloutGrey};
  box-shadow: ${shadows.toolbar};
  background: ${colors.white};
  border-radius: 8px 0 8px 8px;
  overflow: hidden;
  margin: 0;
  padding: 0;
  z-index: 2;
`;

export const CartPillListItemLi = styled.li`
  list-style: none;
  margin: 0;
  padding: 0;

  &:not(:first-child) {
    border-top: 1px solid ${colors.calloutGrey};
  }
`;

export const CartPillListItemLink = styled(RouterLink)<{
  $selected: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 10px;
  color: ${colors.lightContentGrey};
  transition: ${transition};
  font-size: 11px;
  user-select: none;

  background: ${(props) => (props.$selected ? colors.softBlue : 'transparent')};

  --cart-pill-list-item-link-color: ${(props) =>
    props.$selected ? colors.skyBlue : colors.brandBlue};

  &:hover {
    color: ${colors.lightContentGrey};
    text-decoration: none;
    background: ${colors.calloutGrey};
  }
`;

export const CartPillListItemCount = styled.span`
  background: var(--cart-pill-list-item-link-color);
  transition: ${transition};
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${colors.white};
  font-size: 11px;
`;

export const CartPillListItemOrgName = styled.span``;
